import { useCreate, useDelete, useUpdate } from 'admin';

export const useAssignLoadToInspection = () => {
  const { mutate: create } = useCreate();
  const { mutate } = useUpdate();
  const { mutate: deleteInpsectionLoad } = useDelete();

  const assign = (loadId: number, inspectionId: number) => {
    return create({
      dataProviderName: 'inspections',
      invalidates: ['all'],
      resource: '/v1/inspection-loads',

      values: {
        inspection: inspectionId,
        trade_load: loadId,
      },
    });
  };

  const reassign = (loadId: number, inspectionId: number) => {
    return mutate({
      dataProviderName: 'inspections',
      id: loadId,
      invalidates: ['all'],
      resource: '/v1/inspection-loads',
      values: {
        inspection: inspectionId,
      },
    });
  };

  const unassign = (loadId: number) => {
    return deleteInpsectionLoad({
      dataProviderName: 'inspections',
      id: loadId,
      invalidates: ['all'],
      resource: '/v1/inspection-loads',
    });
  };

  return { assign, reassign, unassign };
};
